<!-- Container-fluid starts-->
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">
        <div class="card-body">
          <div echarts [options]="chartOption" class="demo-chart"></div>
        </div>
      </div>
    </div>
<!-- Container-fluid ends-->
